import { FaSteam, FaDiscord, FaVk, FaTelegram } from "react-icons/fa";
import { socials } from "@/data/gamedev-data";

const FloatingActions = () => {
  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col gap-3">
      <div className="text-xs font-mono text-primary/60 text-right mb-1 pr-1">
        {'>> СВЯЗЬ'}
      </div>
      
      {/* Discord студии */}
      <a
        href={socials.discord.url}
        target="_blank"
        rel="noopener noreferrer"
        className="cyber-card p-3 bg-card/90 backdrop-blur-sm neon-glow-blue hover:scale-110 transition-all duration-300 group"
        title={socials.discord.label}
      >
        <FaDiscord className="w-5 h-5 text-primary group-hover:rotate-12 transition-transform" />
      </a>

      {/* VK студии */}
      <a
        href={socials.vk.url}
        target="_blank"
        rel="noopener noreferrer"
        className="cyber-card p-3 bg-card/90 backdrop-blur-sm neon-glow-purple hover:scale-110 transition-all duration-300 group"
        title={socials.vk.label}
      >
        <FaVk className="w-5 h-5 text-secondary group-hover:rotate-12 transition-transform" />
      </a>

      {/* Telegram студии */}
      <a
        href={socials.telegram.url}
        target="_blank"
        rel="noopener noreferrer"
        className="cyber-card p-3 bg-card/90 backdrop-blur-sm neon-glow-pink hover:scale-110 transition-all duration-300 group"
        title={socials.telegram.label}
      >
        <FaTelegram className="w-5 h-5 text-accent group-hover:rotate-12 transition-transform" />
      </a>

      {/* Steam студии */}
      <a
        href={socials.steam.url}
        target="_blank"
        rel="noopener noreferrer"
        className="cyber-card p-3 bg-card/90 backdrop-blur-sm neon-glow-blue hover:scale-110 transition-all duration-300 group"
        title={socials.steam.label}
      >
        <FaSteam className="w-5 h-5 text-primary group-hover:rotate-12 transition-transform" />
      </a>
    </div>
  );
};

export default FloatingActions;
